import { NoteInfoInput, ObjectiveInput } from '../../../types'
import { NoteInfoInputExtended } from '../TargetTemplateModal/types'

// If date is already in UTC just return it
// if not, change it to UTC and then return the UTC value
export const forceUTCDate = (dateString: string): string => {
  if (dateString.includes('Z')) {
    return dateString
  } else if (dateString.lastIndexOf('-') > 20) {
    const toRemove = dateString.split('-')[3]
    return dateString.replace(`-${toRemove}`, '') + 'Z'
  } else {
    return dateString.split('+')[0] + 'Z'
  }
}

export const transformEmployeeTargetBeforeSave = (
  target: ObjectiveInput,
  attachment: string | null | undefined,
  comments: NoteInfoInputExtended[],
  commentFromInput: NoteInfoInputExtended | undefined,
): ObjectiveInput => {
  const transformed = {
    ...target,
    start: forceUTCDate(target.start),
    due: forceUTCDate(target.due),
    attachment,
    noteList: [] as NoteInfoInput[],
  }

  if (!!comments && !!comments.length) {
    transformed.noteList = comments.map((comment) => {
      if (!comment.isNewComment) {
        return { ...comment }
      }
      return { author: comment.author, date: comment.date, text: comment.text }
    })
  }

  if (!!commentFromInput) {
    transformed.noteList.push({ author: commentFromInput.author, date: commentFromInput.date, text: commentFromInput.text })
  }

  if (!attachment) {
    transformed.attachmentDownloadToken = null
  }

  if (transformed.targetAmount === undefined || transformed.targetAmount === null) {
    transformed.currency = undefined
  }

  return transformed
}
